import { combineEpics } from 'redux-observable';

import { createAppUserEpic }                 from './CreateAppUser/CreateAppUserEpic';
import { deleteAppUserEpic }                 from './DeleteAppUser/DeleteAppUserEpic';
import { findAppUsersEpic }                  from './FindAppUsers/FindAppUsersEpic';
import { searchAppUsersEpic }                from './SearchAppUsers/SearchAppUsersEpic';
import { findAppUserEpic }                   from './FindAppUser/FindAppUserEpic';
import { updateAppUserEpic }                 from './UpdateAppUser/UpdateAppUserEpic';
import { removeAppUserFromOrganisationEpic } from './RemoveAppUserFromOrganisation/RemoveAppUserFromOrganisationEpic';
import { findAppUserEventsEpic }             from './FindAppUserEvents/FindAppUserEventsEpic';
import { assignAppUserEventsEpic }           from './AssignAppUserEvents/AssignAppUserEventsEpic';
import { findAppUserOrganisationsEpic }      from './FindAppUserOrganisations/FindAppUserOrganisationsEpic';
import { assignAppUserOrganisationEpic }     from './AssignAppUserOrganisation/AssignAppUserOrganisationEpic';
import { removeAppUserOrganisationEpic }     from './RemoveAppUserOrganisation/RemoveAppUserOrganisationEpic';


export const appUserEpics = combineEpics(
  createAppUserEpic,
  deleteAppUserEpic,
  findAppUsersEpic,
  findAppUserEpic,
  updateAppUserEpic,
  searchAppUsersEpic,
  removeAppUserFromOrganisationEpic,
  findAppUserEventsEpic,
  assignAppUserEventsEpic,
  findAppUserOrganisationsEpic,
  assignAppUserOrganisationEpic,
  removeAppUserOrganisationEpic,
);
